/**
 * 分頁按鈕數值監聽
 */
function paginationListener(data) {
  const paginationNext = document.querySelector(`[data-id="pagination-next"]`);
  const paginationPrev = document.querySelector(`[data-id="pagination-prev"]`);
  
  // 下一頁按鈕監聽
  paginationNext.addEventListener("click", () => {
    data.isInit = false;
    data.currentPage++;
  });

  // 上一頁按鈕監聽
  paginationPrev.addEventListener("click", () => {
    data.isInit = false;
    data.currentPage--;
  });

  // 頁數分頁按鈕監聽
  const allPagination = document.querySelectorAll(`[data-type="pagination"]`);
  allPagination.forEach((item) => {
    item.addEventListener("click", () => {
      const page = item.dataset.page;
      data.isInit = false;
      data.currentPage = page;
    });
  });
}

/**
 * 更換分頁顯示樣式
 * @param {目前頁數} page
 */
// function changePageStyle(page, maxPage) {
//   const allPagination = document.querySelectorAll(`[data-type="pagination"]`);
//   const currentPage = Array.from(allPagination).filter((item) =>
//     item.classList.contains("bg-gray-2")
//   );
//   // 更換目前頁數樣式
//   currentPage[0].classList.remove("bg-gray-2", "text-white");
//   currentPage[0].classList.add("bg-white", "text-gray-2");
//   currentPage[0].removeAttribute("disabled");

//   // 更換目前使用者點擊頁數樣式
//   const nextPage = document.querySelector(`[data-page="${page}"]`);
//   nextPage.classList.remove("bg-white", "text-gray-2");
//   nextPage.classList.add("bg-gray-2", "text-white");
//   nextPage.setAttribute("disabled", true);

//   // 切換上下頁可否點擊狀態
//   const paginationNext = document.querySelector([
//     `[data-id="pagination-next"]`,
//   ]);
//   const paginationPrev = document.querySelector([
//     `[data-id="pagination-prev"]`,
//   ]);

//   if (page == 1) {
//     paginationPrev.setAttribute("disabled", true);
//   } else {
//     paginationPrev.removeAttribute("disabled");
//   }
//   if (page == maxPage) {
//     paginationNext.setAttribute("disabled", true);
//   } else {
//     paginationNext.removeAttribute("disabled");
//   }
// }

export { paginationListener };
